// extracted by mini-css-extract-plugin
export default {"wrapper":"PersonInfo_wrapper__VuNkJ","list__container":"PersonInfo_list__container__h-vd1","list__item":"PersonInfo_list__item__UFUz-","item__title":"PersonInfo_item__title__s25qE"};